import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=15ceb9ba&scoped=true&"
import script from "./errorPage.vue?vue&type=script&lang=js&"
export * from "./errorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ceb9ba",
  null
  
)

export default component.exports